module.exports = __webpack_public_path__ + "static/media/arrow-down.bedd4fe8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow-down.svg
// module id = 1216
// module chunks = 0